import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { useLogicCheckerBreadCrumbs } from 'hooks/useLogicCheckerBreadCrumbs';

import { Breadcrumbs } from 'components/common/Breadcrumbs/Breadcrumbs';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader } from 'components/common';
import { ActivitiesTable } from 'components/widgets/ActivitiesTable/ActivitiesTable';
import { LogicQualityCheckActionsMenu } from 'components/widgets/LogicQualityCheckActionsMenu/LogicQualityCheckActionsMenu';
import { LogicQualityCheckSelectedFilters } from 'components/widgets/LogicQualityCheckSelectedFilter/LogicQualityCheckSelectedFilters';

export const LogicQualityCheckActivitiesPage = () => {
    useFullStoryPageView({ pageName: riskConfig.logicQualityCheck.title });
    const { breadcrumbs } = useLogicCheckerBreadCrumbs({ displayLevel3Activities: true });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader>
                    <ShareInsightButton title={riskConfig.logicQualityCheck.title} link={window.location.href} />
                    <LogicQualityCheckActionsMenu />
                </TreeProgramTopHeader>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.logicQualityCheck.title} />
                    <Breadcrumbs list={breadcrumbs} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <LogicQualityCheckSelectedFilters />
                <ActivitiesTable />
            </MainContent>

            <MainCardRoutingModal queryKeys={['getRowDrillDownActivities', 'getValidationActivitiesDrillDown']} />
        </PageContainer>
    );
};
